var map = {
	"./additionalInfoIcon.svg": 536,
	"./arrowLeftIcon.svg": 537,
	"./arrowMediumTop.svg": 538,
	"./arrowRightIcon.svg": 539,
	"./arrowRightIconSharp.svg": 540,
	"./arrowRightSmallIcon.svg": 541,
	"./arrowScalableIcon.svg": 542,
	"./arrowSelect2.svg": 543,
	"./arrowSelectIcon.svg": 544,
	"./benefit1.svg": 545,
	"./benefit2.svg": 546,
	"./benefit3.svg": 547,
	"./cardsIcon.svg": 548,
	"./circleInfoIcon.svg": 549,
	"./copyIcon copy.svg": 550,
	"./copyIcon.svg": 551,
	"./crossIcon.svg": 552,
	"./crossIcon2.svg": 553,
	"./crossIcon3.svg": 554,
	"./crossIconSmall.svg": 555,
	"./crossSmallIcon.svg": 556,
	"./defaultCategoryIcon.svg": 557,
	"./depNumberIcon.svg": 558,
	"./elfCentralIcon.svg": 559,
	"./equalitySign.svg": 560,
	"./errorIcon.svg": 465,
	"./eyeClosedIcon.svg": 561,
	"./eyeOpenIcon.svg": 562,
	"./favoritesIcon.svg": 563,
	"./favoritesLabelIcon.svg": 564,
	"./filterDivider.svg": 565,
	"./filterIcon.svg": 566,
	"./frequencyIcon.svg": 567,
	"./fsAmountIcon.svg": 568,
	"./fullScreenIcon.svg": 569,
	"./gameIcon.svg": 570,
	"./goldGiftIcon.svg": 571,
	"./hamburgerIcon.svg": 572,
	"./infoIcon.svg": 573,
	"./infoSymbol.svg": 574,
	"./levelBackground.svg": 575,
	"./levelBackgroundNew.svg": 576,
	"./linkIcon.svg": 577,
	"./lockIcon.svg": 578,
	"./lockSharpIcon.svg": 579,
	"./maxBonusAmountIcon.svg": 580,
	"./maxWinFsIcon.svg": 581,
	"./menuIcon.svg": 582,
	"./minDepIcon.svg": 583,
	"./noTournamentIcon.svg": 584,
	"./playIcon.svg": 585,
	"./polygon.svg": 586,
	"./preloaderDotsAnimation.svg": 587,
	"./preloaderSpinnerAnimation.svg": 588,
	"./present2Icon.svg": 589,
	"./presentIcon.svg": 590,
	"./promoIcon.svg": 591,
	"./recentIcon.svg": 592,
	"./search2Icon.svg": 593,
	"./search3Icon.svg": 594,
	"./sharpTickIcon copy.svg": 595,
	"./sharpTickIcon.svg": 596,
	"./smallInfoSymbol.svg": 597,
	"./smoothArrowIcon.svg": 598,
	"./successIcon.svg": 599,
	"./supportIcon.svg": 600,
	"./tag1Icon.svg": 601,
	"./tag2Icon.svg": 602,
	"./tag3Icon.svg": 603,
	"./tag4Icon.svg": 604,
	"./tickIcon.svg": 605,
	"./unverified.svg": 606,
	"./verified.svg": 607,
	"./wagerIcon.svg": 608,
	"./wagerTimeIcon.svg": 609,
	"./warningIcon.svg": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;